import { useContext } from 'react';
import { Redirect, __RouterContext } from 'react-router';

type RedirectStatusProps = { to: string; status: number };
export function RedirectStatus({ to, status }: RedirectStatusProps): JSX.Element {
	const { staticContext } = useContext(__RouterContext);
	if (staticContext) (staticContext as { status: number }).status = status;

	if (to[0] == '/') return <Redirect to={to} />;
	else return <Redirect to={`/${to}`} />;
}
